import { useState } from "react";
import { toast } from "react-toastify";
import { Toast } from "../../config/Toast";
import { convertToRupiah } from "../../helper/RupiahDashboard";
import Modal from "../../components/Modal";
import InputGroup from "../../components/InputGroup";
import MasterBonusService from "../../services/MasterBonus";
import "react-toastify/dist/ReactToastify.css";

const MasterBonusEdit = (props) => {
  console.log(props);
  const data = props;
  const notifySuccess = (message) => toast.success(message, Toast);
  const notifyFailed = (message) => toast.error(message, Toast);

  const [amount, setAmount] = useState(data.data.data.amount);
  const [minKerja, setMinKerja] = useState(data.data.data.min_attendance);
  const [maxKerja, setMaxKerja] = useState(
    data.data.data.max_attendance !== null ? String(data.data.data.max_attendance) : ""
  );
  const [maxKerjaInput, setMaxKerjaInput] = useState(
    data.data.data.max_attendance !== null ? String(data.data.data.max_attendance) : ""
  );

  const clearInput = () => {
    setMaxKerja("");
    setMaxKerjaInput("");
  };

  const submitHandler = () => {
    MasterBonusService.update(data.data.data.id, {
      amount: amount,
      min_attendance: minKerja,
      max_attendance: maxKerja === "Tidak Terbatas" ? null : maxKerjaInput !== null ? maxKerjaInput : null,
      updated_by: props.data.user.id,
    })
      .then(() => {
        props.setModalConfirm(true);
        props.setType("edit");
        // notifySuccess(`Nominal Bonus berhasil diperbaharui`);
      })
      .catch((err) => {
        console.log(err);
        notifyFailed(err.response.data.message);
      });

    props.closeClick();
  };

  return (
    <Modal
      activeModal={props.activeModal}
      title="Edit Aturan Bonus"
      closeClick={props.closeClick}
      submitHandler={submitHandler}
      type="Simpan"
    >
      <div className="d-d-flex flex-column w-100">
        <div className="d-flex justify-content-start align-items-center">
          <h6 className="fw-bold">Frekuensi Kerja per Periode</h6>
        </div>

        <div className="w-100 p-0 m-0 mt-4 d-flex gap-2">
          <div style={{ width: "100%" }}>
            <div className="d-flex justify-content-start align-items-center p-0 m-0 w-100">
              <h6>Minimal Kerja</h6>
            </div>
            <input
              className="form-control"
              list="datalistMinKerja"
              value={minKerja}
              onChange={(e) => setMinKerja(e.target.value)}
              placeholder="ketik minimal kerja"
              type="number"
              min="0"
              required
            />
          </div>

          <div style={{ width: "100%" }}>
            <div className="d-flex align-items-center p-0 m-0 w-100" style={{ justifyContent: "space-between" }}>
              <h6>Maximal Kerja</h6>
              <span style={{ cursor: "pointer" }} onClick={() => clearInput()} className="me-2">
                <i className="fa fa-trash"></i>
              </span>
            </div>
            {maxKerjaInput || maxKerja === "inputManual" ? (
              <input
                className="form-control"
                value={maxKerjaInput}
                onChange={(e) => setMaxKerjaInput(e.target.value)}
                placeholder="ketik maximal kerja"
                type="number"
                min={minKerja}
                disabled={minKerja === ""}
                required
              />
            ) : (
              <select className="w-100 form-select" value={maxKerja} onChange={(e) => setMaxKerja(e.target.value)} disabled={minKerja === ""}>
                <option selected value="" disabled>
                  pilih maximal kerja
                </option>
                <option value={null}>Tidak Terbatas</option>
                <option value="inputManual">Input Manual</option>
              </select>
            )}
          </div>
        </div>

        <div style={{ width: "100%" }} className="mt-4">
          <div className="d-flex justify-content-start align-items-center p-0 m-0 w-100">
            <h6>Amount</h6>
          </div>
          <InputGroup
            button="btn btn-primary"
            withForm={false}
            required={true}
            title="Rp"
            layout="left"
            disabled={true}
            placeholder="Masukan amount"
            type="text"
            value={convertToRupiah(amount || 0)}
            onChange={(e) => {
              let numericValue = e.target.value.replace(/\D/g, "");
              if (numericValue.length > 1 && numericValue.startsWith("0")) {
                numericValue = numericValue.replace(/^0+/, "");
              }
              if (numericValue === "") {
                numericValue = "0";
              }

              setAmount(numericValue);
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default MasterBonusEdit;
